import logo from './logo.svg';
import './App.css';
import React from 'react';
import CityButtons from './component/cityButtons/cityButtons';
import Logo from './component/Logo/logo.js';
import TranslatorComponent from './component/translator/translator.js';



function App() {

  document.title = "Babe";

  return (
    <div className="App">
      <Logo></Logo>
      <TranslatorComponent />
      <CityButtons />
    </div>
  );
};

export default App;
